<script>
import { Account, ShoppingCart, Location, Merchant } from './functions.js'

import LocationModal from './components/shared/LocationModal.vue'
import PrivacyConsent from './components/shared/PrivacyConsent.vue'

export default {
  name: 'App',
  components: {
    LocationModal,
    PrivacyConsent
  },
  data () {
    return {
      Account,
      Location,
      Merchant,
      ShoppingCart,
      loaded: false,
      showLocationModal: false,
    }
  },
  watch:{
    $route (to, from){
     if(to.name != "passwordReset")
     {
        if (!Location.location) {
          this.showLocationModal = true;
        }
     }
    
    }
  }, 
  methods: {
    reload () {
      this.showLocationModal = false
      window.location.reload();
    },
    async getPrivacyConsent()
    {
      var check_consent = this.$cookies.get("gfs_privacy");
      if(!check_consent)
      {
        var consent = await this.$refs.privacyConsent.show({position: 'bottom'});
        if(consent)
        {
           this.$cookies.set("gfs_privacy", 1, "30d");
        }

      }
      
    }
  },
  mounted () {
    setTimeout(()=>{
      // Load Location
     if(this.$route.name != "passwordReset")
     {
        if (!Location.location) {
          this.showLocationModal = true;
        }
     }  


      this.loaded = true;
    
      this.getPrivacyConsent();

    },1000)
  }
}
</script>

<template>
<div>
  <div id="app" class="body-wrapper">
    <router-view v-if="loaded"/>
    <PrivacyConsent ref="privacyConsent" />
    <LocationModal v-if="showLocationModal" @onSelectLocation="reload" :allowClose="false" />
  </div>

   <!-- preloader area start -->
  <div class="preloader" id="preloader" v-if="!loaded">
      <div class="preloader-inner">
          <div class="spinner">
              <div class="dot1"></div>
              <div class="dot2"></div>
          </div>
      </div>
  </div>
  <!-- preloader area end -->
</div>

</template>



// WEBPACK FOOTER //
// src/App.vue